import { TreeNode } from 'primeng/api';
import { environment } from "src/environments/environment";
import { formatQuantity } from '../shared/pipes/format-quantity.pipe';

function getDateTime(date: any) {
  const parsedDate = new Date(date);
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
}

function toTitleCase(str: string): string {
  if (!str) return str;
  return str.toLowerCase().split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
}

export class Discrepancy {
  id!: number;
  patientName!: string;
  patientId!: string;
  medDesc!: string;
  medId!: string;
  loc!: string;
  adminId!: string;
  serviceGroup!: string;
  var!: string;
  uom!: string;
  admin!: Date;
  amount:any
  csn!: string
  varDate!: Date;
  transType: any;
  resolutionCoding!: string;
  entityType: string | null = null;
  children!: any[];
  maapKey!: string;
  mrnNum!: string;
  wasteEntryComment!: string;
  comment!: string;
  lanId!: string;
  employeeName!: string;
  userGrp!: string;
  adminGroup!: string;
  uniqueKey2!: string;
  discDesc!: string;
  followUp!: string;
  source!: string;
  expectedDrugConc!: number;
  expectedDrugConcUOM!: string;
  practiceIssue: any = [];
  _1stAssayResults!: number;
  _2ndAssayResults!: number;
  _3rdAssayResults!: number;
  _HPLCAssayResults!: number;
  _PendingHPLCResults!: number;
  _PendingLabResults!: number;
  _InSource!: boolean;
  _OutSource!: boolean;
  _Commercial!: boolean;
  _HQI!: boolean;  
  _Pass!: boolean;  
  _Fail!: boolean;  
  _failOption!: string;
  _AssayRiskScore!: number;
  loggedInUserName!: string;
  loggedInUserId!: string;
  witnessName!: string;
  witnessId!: string;
  adminType!: string;
  updatedAt!: Date;
  notRecieved = false;
  notPerformed = false;
  wasteAmountRecieved!: number;
  expectedWaste!: number;
  varDateString!: string | null;
  wasteUOM2!: string;
  waste!: number;
  U!: string;
  V!: string;
  ColV!: string;
  addAssay = true;
  isUpdated = false;
  region!: string;
  campus!: string;
  facility!: string;
  regionId!: string;
  campusId!: string;
  facilityId!: string;
  data: any = {}
  serialIdentifier!: string
  override!: boolean;
  medGroupName!:string;
  shareThis!:boolean;
  mappAssayRecomended!:boolean;
  wasteAmountReceived: any;
  isLinked:any
  verified:any;
  resCode:any;

  createdAt!:Date;
  sourceResCode!:string;
  static fromJSON(object: any) {

    const discrepancy = new Discrepancy();
    discrepancy.children = object['children'];
    discrepancy.id = object._id;
    discrepancy.patientName = toTitleCase(object.patientName);
    discrepancy.employeeName = toTitleCase(object.employeeName);
    discrepancy.mrnNum = object.mrnNum;
    discrepancy.csn = object.csn;
    discrepancy.medDesc = object.medDesc;
    // if(object["medID"] == undefined)
    // discrepancy.medId = object["uniqueMedId"]
    // else
    discrepancy.medId = object.medID;
    discrepancy.lanId = object.lanID;
    // discrepancy.mrnNum = object.mrnNum.replace("Error", "NoEHR");
    discrepancy.loc = object.bedDev;
    discrepancy.adminId = object.lanID;
    discrepancy.amount  = ""
    try{
      const varValue = object.discrepancy !== undefined ? object.discrepancy : object.amount;
      discrepancy.var = formatQuantity(varValue);
    }
    catch {
      discrepancy.var = ""
    }
    discrepancy.uom = object.uom;
    discrepancy.waste = object.waste;
    discrepancy.admin = getDateTime(object.varDate);
    discrepancy.transType = object.transType;
    discrepancy.resolutionCoding = object.resolution;
    discrepancy.maapKey = object.maapKey;
    discrepancy.comment = object.comment;
    discrepancy.userGrp = object.adminGroup;
    discrepancy.serviceGroup = object.serviceGroup;
    discrepancy.adminGroup = object.adminGroup;
    discrepancy.uniqueKey2 = object.uniqueKey2;
    discrepancy.followUp = object.followUp;
    discrepancy.source = object.source;
    discrepancy.isLinked = object.isLinked;
    discrepancy.varDate = getDateTime(object.varDate);
    discrepancy.resCode = object.resCode;

    if (environment.convert_times && object.varDate) {
      // Convert UTC ISO string to local time string for display
      const utcDate = new Date(object.varDate);
      discrepancy.varDateString = utcDate.toLocaleString("en-US", {
        localeMatcher: "best fit",
        timeZoneName: "short"
      });
    } else if (object.varDate) {
      // Use the date as-is (assume local time)
      discrepancy.varDateString = new Date(object.varDate).toLocaleString("en-US", {
        localeMatcher: "best fit",
        timeZoneName: "short"
      });
    } else {
      discrepancy.varDateString = "";
    }

    discrepancy.expectedDrugConc = object.expectedDrugConc;
    discrepancy.expectedDrugConcUOM = object.expectedDrugConcUOM;
    if(object.practiceIssue){
      discrepancy.practiceIssue = object.practiceIssue;
    } else {
        discrepancy.practiceIssue = [];
    }
    discrepancy._1stAssayResults = object._1stAssayResults;
    discrepancy._2ndAssayResults = object._2ndAssayResults;
    discrepancy._3rdAssayResults = object._3rdAssayResults;
    discrepancy._HPLCAssayResults = object._HPLCAssayResults;
    discrepancy._PendingHPLCResults = object._PendingHPLCResults;
    discrepancy._PendingLabResults = object._PendingLabResults;
    discrepancy._InSource = object._InSource;
    discrepancy._OutSource = object._OutSource;
    discrepancy._Commercial = object._Commercial;
    discrepancy._HQI = object._HQI;
    discrepancy._AssayRiskScore = object._AssayRiskScore;
    discrepancy.loggedInUserName = object.loggedInUserName;
    discrepancy.loggedInUserId = object.loggedInUserId;
    discrepancy.witnessName = object.witnessName;
    discrepancy.witnessId = object.witnessId;
    discrepancy.adminType = object.adminType;
    discrepancy.updatedAt = object.updatedAt;
    discrepancy.notRecieved = object.notRecieved;
    discrepancy.notPerformed = object.notPerformed;
    discrepancy._Pass = object._Pass;
    discrepancy._Fail = object._Fail;
    discrepancy._failOption = object._failOption;
    discrepancy.wasteAmountRecieved = object.wasteAmountRecieved;
    discrepancy.wasteEntryComment = object.wasteEntryComment;
    discrepancy.expectedWaste = object.expectedWaste;
    discrepancy.wasteUOM2 = object.wasteUOM2;
    discrepancy.serialIdentifier = object.serialIdentifier || "";
    discrepancy.U = object.U || "";
    discrepancy.V = object.V || "";
    discrepancy.isUpdated = true;
    discrepancy.region = object.region;
    discrepancy.campus = object.campus;
    discrepancy.facility = object.facility;
    discrepancy.regionId = object.regionId;
    discrepancy.campusId = object.campusId;
    discrepancy.facilityId = object.facilityId;
    discrepancy.mappAssayRecomended = object.mappAssayRecomended;
    if(object.overide){
      discrepancy.resolutionCoding = "Not Performed"
    }
    if(!["",null, undefined].includes(object.medGroupName))
    discrepancy.medGroupName = object.medGroupName;
    else
    discrepancy.medGroupName = object.medDesc;
    discrepancy.createdAt = object.createdAt;
    discrepancy.sourceResCode = object.sourceResCode;
    
    return discrepancy;
  }

  toJson() {
    const data = {};
    (data as any)["patientName"] = this.patientName;
    (data as any)["mrnNum"] = this.patientId;
    (data as any)['csn'] = this.csn;
    (data as any)["medDesc"] = this.medDesc;
    (data as any)["bedDev"] = this.loc;
    (data as any)["employeeName"] = this.employeeName;
    (data as any)["amount"] = this.var;
    (data as any)["wasteUOM2"] = this.wasteUOM2;
    (data as any)["varDate"] = this.varDate;
    (data as any)["varDateString"] = this.varDateString;
    (data as any)["source"] = this.source;
    (data as any)["resolution"] = this.resolutionCoding;
    (data as any)["adminGroup"] = this.adminGroup;
    (data as any)["wasteEntryComment"] = this.wasteEntryComment;
    (data as any)["lanID"] = this.adminId;
    (data as any)["notPerformed"] = this.notPerformed;
    (data as any)["_Pass"] = this._Pass;
    (data as any)["_Fail"] = this._Fail;
    (data as any)["_failOption"] = this._failOption;
    (data as any)["_1stAssayResults"] = this._1stAssayResults;
    (data as any)["_2ndAssayResults"] = this._2ndAssayResults;
    (data as any)["_3rdAssayResults"] = this._3rdAssayResults;
    (data as any)["_HPLCAssayResults"] = this._HPLCAssayResults;
    (data as any)["_PendingHPLCResults"] = this._PendingHPLCResults;
    (data as any)["_PendingLabResults"] = this._PendingLabResults;
    (data as any)["_InSource"] = this._InSource;
    (data as any)["_OutSource"] = this._OutSource;
    (data as any)["_Commercial"] = this._Commercial;
    (data as any)["_HQI"] = this._HQI;
    (data as any)["_AssayRiskScore"] = this._AssayRiskScore;
    (data as any)["practiceIssue"] = this.practiceIssue;
    (data as any)["regionId"] = this.regionId; //took out the [0] I think it was causing issues and taking the first element of the array so if Arizona it would just take a;
    (data as any)["campusId"] = this.campusId;
    (data as any)["facilityId"] = this.facilityId;
    (data as any)["medId"] = this.medId;
    (data as any)["mappAssayRecomended"] = this.mappAssayRecomended;
    (data as any)["wasteAmountRecieved"] = this.wasteAmountRecieved;
    (data as any)["expectedWaste"] = this.expectedWaste;
    return data;
  }

  copyToAssayRecord() {
    let assayRecord = new Discrepancy();
    assayRecord.patientName = this.patientName
    assayRecord.patientId = this.patientId
    assayRecord.csn = this.csn
    assayRecord.medDesc = this.medDesc
    assayRecord.loc = this.loc
    assayRecord.employeeName = this.employeeName
    assayRecord.var = this.var
    assayRecord.wasteUOM2 = this.wasteUOM2
    assayRecord.wasteAmountRecieved = this.wasteAmountRecieved
    assayRecord.expectedWaste = this.expectedWaste
    assayRecord.varDate = this.varDate
    assayRecord.varDateString = this.varDateString
    assayRecord.source = this.source
    assayRecord.resolutionCoding = "Pending Assay (checking on code)"
    assayRecord.adminGroup = this.adminGroup
    assayRecord.adminId = this.adminId
    assayRecord.source = "Added Waste Assay";
    assayRecord.regionId = this.regionId; //took out the [0] I think it was causing issues and taking the first element of the array so if Arizona it would just take a
    assayRecord.campusId = this.campusId;
    assayRecord.facilityId = this.facilityId;
    assayRecord.mappAssayRecomended = this.mappAssayRecomended;
    assayRecord.medId = this.medId
    assayRecord.isLinked = this.isLinked

    assayRecord = Object.assign(assayRecord, this.data);
    return assayRecord;
  }

  static toTreeNode(discrepancy: Discrepancy): TreeNode {
    return ({ data: Object.assign({}, discrepancy), children: [{ data: { label: "ADC Data" }, children: [{}] }, { data: { label: "EHR Data" }, children: [{}] }, { data: { label: "Add Transaction" }, children: [{}] }], leaf: true, expanded: false, parent: null } as unknown) as TreeNode
  }

}
